enum CurrencySymbols {
  AZN = '₼',
  USD = '$',
  EUR = '€'
}
export const getSymbolFromCurrency = (
  currency: string
): CurrencySymbols | string => CurrencySymbols[currency] || currency;
